<svg class="icon language-icon"
    [nTooltip]="languageListTemplate"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    [(nTooltipVisible)]="tooltipVisible"
    [nTooltipPlacement]="'bottom'">
    <use [attr.xlink:href]="'#app-icon-language-' + i18nService.language" ></use>
</svg>

<ng-template #languageListTemplate>
    <div class="header-tip-box">
        <ul>
            <li *ngFor="let item of languageList"
                [class.hidden]="item.hide"
                (click)="item.command()">
                <span>{{ item.label }}</span>
            </li>
        </ul>
    </div>
</ng-template>
